(function() {
    'use strict';

    angular.module('ecrd.states')
        .controller('StateInfoController', StateInfoController);

    StateInfoController.$inject = ['RecordMetadataService', 'CrdConfigurationService'];

    function StateInfoController(RecordMetadataService, CrdConfigurationService) {
        var vm = this;

        // Datos informativos (valor, usuario, fecha, firma)
        vm.info = {};

        var _eventListeners = [];

        vm.label = CrdConfigurationService.getLabelSingular();

        vm.stateName = null;
        vm.auto = false;

        vm.$onInit = function() {
            vm.stateName = CrdConfigurationService.getStates().getState(vm.id).getName();
            _setUpListeners();
            _reloadInfo();
        };

        function _reloadInfo() {
            if (vm.formId) {
                vm.info = RecordMetadataService.getFormState(vm.id, vm.formId, vm.listIndices);
            } else {
                vm.info = RecordMetadataService.getGlobalState(vm.id);
            }

            vm.auto = vm.info && vm.info.author && vm.info.author.email === 'system@sharecrf.com';
        }

        vm.$onDestroy = function() {
            if (vm.formId) {
                _tearDownListeners();
            }
        };

        function _setUpListeners() {
            // Al recargar los metadatos se calcula de nuevo el estado global/del formulario
            _eventListeners.push(RecordMetadataService.events.on('load', _reloadInfo));
        }

        function _tearDownListeners() {
            angular.forEach(_eventListeners, function(deregister) {
                deregister();
            });
        }

    }
})();
